const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID; // e.g. G-XXXXXXXXXX
const SCRIPT_ID = "ga-gtag";

function insertScript(src) {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  s.id = SCRIPT_ID;
  document.head.appendChild(s);
  return s;
}

export function enableGoogleAnalytics() {
  if (!GA_ID) return;

  // If previously disabled via ga-disable flag, re-enable
  window[`ga-disable-${GA_ID}`] = false;

  // Avoid double-inject
  if (document.getElementById(SCRIPT_ID)) return;

  // Load gtag
  insertScript(
    `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`,
  );

  // Init dataLayer + gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = window.gtag || gtag;

  // Basic GA4 init
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, {
    anonymize_ip: true,
    send_page_view: false,
  });
}

export function disableGoogleAnalytics() {
  if (!GA_ID) return;

  // Prevent hits even if gtag exists
  window[`ga-disable-${GA_ID}`] = true;

  // Optional: remove the script tag (doesn't “undo” everything, but good hygiene)
  const existing = document.getElementById(SCRIPT_ID);
  if (existing && existing.parentNode)
    existing.parentNode.removeChild(existing);
}
